import Plyr from 'plyr';
import {detectMob} from './mobileHelper';
import { getUrlParams } from './urlHelper';

const controls = `
<div class="plyr__controls">
    <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
        <svg class="icon--pressed" role="presentation">
           <use xlink:href="#plyr-pause"></use>
	    </svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
    </button>
    <div class="plyr__controls__item plyr__progress__container" style="padding-right: 10px;"></div>
    <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
    </button>
    <div class="plyr__volume">
        <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
    </div>
    <button class="plyr__controls__item plyr__control" type="button" data-plyr="fullscreen" id="plyr__control__fullscreen">
        <svg class="icon--pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-exit-fullscreen"></use></svg>
        <svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-enter-fullscreen"></use></svg>
    </button>
</div>
<div id="mask-panel" style="background:black; width:100%; height: 100%; position: absolute; top:0; left:0; z-index:2; opacity:0;">
    <div id="loading-panel" style="color:white; position: absolute; top:50%; left:50%; transform:translate(-50%, -50%); display:none;">
        <div class="sk-spinner sk-spinner-double-bounce">
            <div class="sk-double-bounce1"></div>
            <div class="sk-double-bounce2"></div>
        </div>
    </div>
</div>
<div id="play-button-panel" style="width:100%; height:100%; position:absolute; top:0; left:0; z-index:3;">
<button id="play-button" type="button" class="plyr__control plyr__control--overlaid" data-plyr="play">
    <svg aria-hidden="true" focusable="false"><use xlink:href="#plyr-play"></use></svg>
    <span class="plyr__sr-only">Play</span>
</button>
</div>
`;

const bannerControls = `
<div class="plyr__controls">
    <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
    </button>
<div class="plyr__controls__item plyr__progress__container" style="padding-right: 10px;">
    <div class="plyr__progress">
        <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
        <span role="tooltip" class="plyr__tooltip">00:00</span>
    </div>
</div>
    <div class="plyr__time plyr__time--current" aria-label="Current time" style="padding-right: 10px;">00:00</div>
    <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
    <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
    </button>
    <div class="plyr__volume">
        <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
    </div>
    <button class="plyr__controls__item plyr__control" type="button" data-plyr="fullscreen" id="plyr__control__fullscreen">
        <svg class="icon--pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-exit-fullscreen"></use></svg>
        <svg class="icon--not-pressed" aria-hidden="true" focusable="false"><use xlink:href="#plyr-enter-fullscreen"></use></svg>
    </button>
</div>
<div id="mask-panel" style="background:black; width:100%; height: 100%; position: absolute; top:0; left:0; z-index:2; opacity:0;">
    <div id="loading-panel" style="color:white; position: absolute; top:50%; left:50%; transform:translate(-50%, -50%); display:none;">
    <div class="sk-spinner sk-spinner-double-bounce">
            <div class="sk-double-bounce1"></div>
            <div class="sk-double-bounce2"></div>
        </div>
</div>
</div>
<div id="play-button-panel" style="width:100%; height:100%; position:absolute; top:0; left:0; z-index:3;">
    <button id="play-button" type="button" class="plyr__control plyr__control--overlaid" data-plyr="play"><svg aria-hidden="true" focusable="false"><use xlink:href="#plyr-play"></use></svg><span class="plyr__sr-only">Play</span></button>
</div>
`;

const setCommonHandlers = (plyrInstance) => {
    const container = plyrInstance.elements?.original;

    plyrInstance.on('play', event => {
        event.target.querySelector('#play-button-panel').style.display = 'none';
        event.target.querySelector('#mask-panel').style.transition = 'opacity 1s ease-in';
        event.target.querySelector('#mask-panel').style.opacity = 0;
    });

    plyrInstance.on('pause', event => {
        event.target.querySelector('#play-button-panel').style.display = 'block';
        event.target.querySelector('#mask-panel').style.transition = '';
        event.target.querySelector('#mask-panel').style.opacity = 1;
    });

    plyrInstance.on('statechange', event => {
        const loadingPanel = event.target.querySelector('#loading-panel');

        if (event.detail.code == 3 || (event.detail.code == -1 && event.detail.plyr.config.youtube.start)) {
            event.target.querySelector('#play-button-panel').style.display = 'block';
            event.target.querySelector('#mask-panel').style.transition = '';
            event.target.querySelector('#mask-panel').style.opacity = 1;
            event.target.querySelector('#loading-panel').style.display = 'block';
        }
        else if (event.detail.code == 1) {
            event.target.querySelector('#play-button-panel').style.display = 'none';
            event.target.querySelector('#loading-panel').style.display = 'none';
            event.target.querySelector('#mask-panel').style.transition = 'opacity 1s ease-in';
            event.target.querySelector('#mask-panel').style.opacity = 0;
        }
        else if (loadingPanel) {
            loadingPanel.style.display = 'none';
        }
    });

    plyrInstance.on('enterfullscreen', event => {
        document.body.classList.add("plyr-fullscreen-entered")
    });

    plyrInstance.on('exitfullscreen', event => {
        document.body.classList.remove("plyr-fullscreen-entered")
    });

    plyrInstance.once('ready', event => {
        let elem = event.target.querySelector('#play-button-panel');
        elem.style.cursor = 'pointer';
        elem.onclick = function () {
            plyrInstance.play();
        };

        elem = event.target.querySelector('#mask-panel');
        elem.style.cursor = 'pointer';
        elem.onclick = function () {
            if (plyrInstance.playing)
                {plyrInstance.pause();}
            else
                {plyrInstance.play();}
        };

        if (detectMob()) {
            event.target.querySelector('#plyr__control__fullscreen').style.display = 'block';
        }
    });
}

const getParamFromUrl = (urlString, paramValue) => {
    const params = getUrlParams(urlString);
    return params.search[paramValue];
}

const getParams = (element) => {

    const iframe = element && element.getElementsByTagName('iframe')[0];
    let result = {
        settings: ['quality'],
        resetOnEnd: true,
        ratio: '16:9'
    }

    if (iframe) {
        const urlString = iframe.getAttribute('src');
        const start = parseInt(getParamFromUrl(urlString, 'start'));

        if (!isNaN(start) && start > 0) {
            result = { ...result, youtube: { start: start }}
        }
    }

    return result;
}

const livePlyr = (id) => {
    const element = typeof id == 'string' ? `#${id}` : id;
    const params = getParams(element);

    const player = new Plyr(element, {
        ...params,
        autoplay: true,
        fullscreen: { enabled: detectMob() },
        controls: controls,
        clickToPlay: false
    });

    setCommonHandlers(player);
    return player;
}

const videoPlyr = (id, forcedParams) => {
    const element = typeof id == 'string' ? `#${id}` : id;
    const params = getParams(element);
    const player = new Plyr(element, {
        ...params,
        fullscreen: { enabled: true },
        controls: bannerControls,
        clickToPlay: true,
        ...forcedParams
    });
    setCommonHandlers(player);
    return player;
}

export {livePlyr, videoPlyr}